import { LogicContext } from '../types';
import { getCategory } from '../utils';

import Window from '../../../ports-frontend/Window';
import config from '../../../config';
import { getLocale } from '../../../utils';

export const getCategoriesLayoutContent = async (context: LogicContext) => {
  const {
    callbackMode,
    shuffleGames,
    multiJackpots,
    currentJackpotsV2,
    currentTables,
    currentPersonalizedBanners,
    controllersData,
    user,
    strikeGoldData,
  } = context;
  const locale = getLocale(config);
  const currency = user?.currency || config.default_currency;
  const { loggedIn } = user;
  const { drawnGame } = shuffleGames;
  if (!controllersData?.categories) {
    return {
      updates: [],
    };
  }
  const windowInnerWidth = await Window.getInnerWidth();

  const categoriesOnPage = controllersData.categories!.components.filter(
    ([id, v]) => v.type === 'Category'
  ).length;
  const updates = controllersData.categories!.components.map(([id, entry]) => ({
    type: 'setLayoutProperty',
    data: {
      path: `components.${id}.properties`,
      value: {
        category: getCategory({
          category: {
            ...entry.properties,
            categoriesOnPage,
          },
          multiJackpots,
          currentJackpotsV2,
          currentTables,
          currentPersonalizedBanners,
          shuffleGame: drawnGame,
          windowInnerWidth,
          currency,
          locale,
          strikeGoldData,
        }),
        currency,
        loggedIn,
        locale,
        callbackMode,
        visible: !context.isGameModalForMobileOpened,
        displayInMainSection: !!context.currentLayout?.components
          .SideNavigation,
      },
    },
  }));

  return {
    updates,
  };
};
